
// Import Actions
import clone from 'lodash/clone';

import {
    LOAD_SELECTED_LEAD_FORM,
    LOAD_PRE_SELECT_FORM_AND_OPEN_LEADFORM,
    LOAD_FORM_FILTERS,
    LOAD_FORM_SUBAREAS,
    LOAD_LEAD_FORM_DATA,
    FETCHING_LEAD_FORM_DATA,
    TOGGLE_LEAD_FORM_STATE,
    SUBMITTING_LEAD_FORM,
    SET_VM_EVENT_REDIRECT_URL,
    SET_LEAD_FORM_VISIBLE_COUNT,
    UPDATE_LEAD_FORM_VISIBLE_COUNT,
    LOAD_PRE_LOADED_LEAD_FORM_DATA,
    LOAD_VENUE_SLIDE_DATA,
    LOAD_ACTIVE_TRIGGER_SLIDE, TOGGLE_VENUE_LEAD_FORM_STATE,
    TOGGLE_PRE_LEADFORM_BUTTON_STATUS,
    LOAD_FORM_PARAMS,
    LOAD_POST_LEAD_FORM_VERIFIED_DATA,
    GET_CURRENT_SELECTED_CITY,
    TOGGLE_HOME_LEAD_FORM_STATE,
    TOGGLE_VENUE_HOME_LEAD_FORM_STATE,
    LOAD_PRE_SELECT_FORM_AND_OPEN_HOME_LEADFORM
} from '../actions/LeadActions';
import {vmLeadformCountStats} from '../../util/vmCookieHandler';
import { setVmFormCount } from '../../util/vmStorageHandler';
import { VENUE_MODEL } from '../../constants/constants';

// Initial State
const initialState = {
    cities: [],
    occasions: [],
    isLeadFormVisible: false,
    isHomeLeadFormVisible: false,
    leadFormTriggerCode: '',
    leadFormCode: 'homepage',
    isFetchingLeadForm: false,
    leadFormData: {},
    eventSearchUrl: '',
    isPlanningEvent: false,
    preLoadedLeadFormData: {},
    postVerificationFormData: {},
    venueSlideData: {},
    activeTriggerSlide: '',
    leadformVisibleCount: 0,
    selectedVenue: {},
    isPreLeadFormButtonVisible: false,
    selectedLeadForm: {},
    leadFormType:VENUE_MODEL,
    iscurrentcity:''
};

const LeadReducers = (state = initialState, action) => {
    let leadformVisibleCount = state.leadformVisibleCount ? state.leadformVisibleCount : 0;
    switch (action.type) {

        case TOGGLE_PRE_LEADFORM_BUTTON_STATUS:
            return {
                ...state,
                isPreLeadFormButtonVisible: action.isPreLeadFormButtonVisible,
                leadFormTriggerCode: !!action.isPreLeadFormButtonVisible ? 'auto' : ''
            };

        case LOAD_VENUE_SLIDE_DATA:
            return {
                ...state,
                venueSlideData: action.venueSlideData,
            };
            case GET_CURRENT_SELECTED_CITY:
                return {
                    ...state,
                    iscurrentcity: action.iscurrentcity,
                };
        case LOAD_ACTIVE_TRIGGER_SLIDE:
            return {
                ...state,
                activeTriggerSlide: action.activeTriggerSlide,
            };

        case LOAD_PRE_LOADED_LEAD_FORM_DATA:
            return {
                ...state,
                preLoadedLeadFormData: action.preLoadedLeadFormData,
            };

        case LOAD_POST_LEAD_FORM_VERIFIED_DATA:
            return {
                ...state,
                postVerificationFormData: action.postVerificationFormData,
            };

        case LOAD_LEAD_FORM_DATA:
            return {
                ...state,
                leadFormData: action.leadFormData,
                isFetchingLeadForm: action.isFetchingLeadForm,
            };

        case FETCHING_LEAD_FORM_DATA:
            return {
                ...state,
                isFetchingLeadForm: action.isFetchingLeadForm,
            };

        case LOAD_FORM_FILTERS:
            return {
                ...state,
                occasionFilters: action.occasionFilters,
                venuetypeFilters: action.venuetypeFilters,
                isBaseFiltersLoaded: action.isBaseFiltersLoaded,
                isBaseFiltersLoading: action.isBaseFiltersLoading,
            };

        case LOAD_FORM_SUBAREAS:
            return {
                ...state,
                isLocationFiltersLoaded: action.isLocationFiltersLoaded,
                isLocationFiltersLoading: action.isLocationFiltersLoading,
                locationFilters: action.locationFilters,
            };

        case TOGGLE_LEAD_FORM_STATE:

            if (!!action.isLeadFormVisible) {
                leadformVisibleCount += 1;
                setVmFormCount(leadformVisibleCount);
                vmLeadformCountStats();
            }
            return {
                ...state,
                isLeadFormVisible: action.isLeadFormVisible,
                leadformVisibleCount: leadformVisibleCount,
                leadFormCode: action.leadFormCode,
                leadFormTriggerCode: action.leadFormTriggerCode,
                selectedVenue: action.selectedVenue,
            };
            case TOGGLE_HOME_LEAD_FORM_STATE:

            if (!!action.isHomeLeadFormVisible) {
                leadformVisibleCount += 1;
                setVmFormCount(leadformVisibleCount);
                vmLeadformCountStats();
            }
            return {
                ...state,
                isHomeLeadFormVisible: action.isHomeLeadFormVisible,
                leadformVisibleCount: leadformVisibleCount,
                leadFormCode: action.leadFormCode,
                leadFormTriggerCode: action.leadFormTriggerCode,
                selectedVenue: action.selectedVenue,
            };

        case SUBMITTING_LEAD_FORM:
            return {
                ...state,
                isPlanningEvent: action.isPlanningEvent,
            };

        case SET_VM_EVENT_REDIRECT_URL:
            return {
                ...state,
                eventSearchUrl: action.eventSearchUrl,
            };

        case SET_LEAD_FORM_VISIBLE_COUNT:
            return {
                ...state,
                leadformVisibleCount: action.leadformVisibleCount,
            };

        case UPDATE_LEAD_FORM_VISIBLE_COUNT:
            return {
                ...state,
                leadformVisibleCount: action.leadformVisibleCount,
            };

        case TOGGLE_VENUE_LEAD_FORM_STATE:
            return {
                ...state,
                isLeadFormVisible: action.isLeadFormVisible,
                selectedVenue: action.selectedVenue,
            };
        case TOGGLE_VENUE_HOME_LEAD_FORM_STATE:
            return {
                ...state,
                isHomeLeadFormVisible: action.isHomeLeadFormVisible,
                selectedVenue: action.selectedVenue,
            };
        case LOAD_FORM_PARAMS:
            return {
                ...state,
                cities: action.cities,
                occasions: action.occasions,
            };

        case LOAD_PRE_SELECT_FORM_AND_OPEN_LEADFORM:
            if (!!action.isLeadFormVisible) {
                leadformVisibleCount += 1;
                setVmFormCount(leadformVisibleCount);
                vmLeadformCountStats();
            }
            return {
                ...state,
                selectedLeadForm: action.selectedLeadForm,
                isLeadFormVisible: action.isLeadFormVisible,
                leadformVisibleCount,
                leadFormCode: action.leadFormCode,
                leadFormTriggerCode: action.leadFormTriggerCode,
                selectedVenue: action.selectedVenue,
                leadFormType : action.leadFormType
            };
        case LOAD_PRE_SELECT_FORM_AND_OPEN_HOME_LEADFORM:
            if (!!action.isHomeLeadFormVisible) {
                leadformVisibleCount += 1;
                setVmFormCount(leadformVisibleCount);
                vmLeadformCountStats();
            }
            return {
                ...state,
                selectedLeadForm: action.selectedLeadForm,
                isHomeLeadFormVisible: action.isHomeLeadFormVisible,
                leadformVisibleCount,
                leadFormCode: action.leadFormCode,
                leadFormTriggerCode: action.leadFormTriggerCode,
                selectedVenue: action.selectedVenue,
                leadFormType : action.leadFormType
            };
        case LOAD_SELECTED_LEAD_FORM:
            return {
                ...state,
                selectedLeadForm: clone(action.selectedLeadForm),
            };

        default:
            return state;
    }
};
export const getSelectedLeadForm = state => state.newleadform.selectedLeadForm;
// Export Reducer
export default LeadReducers;
